import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SearchInterface = ({ onSearch, isSearching = false }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (searchQuery?.trim()) {
      onSearch(searchQuery?.trim());
    }
  };

  const handleClear = () => {
    setSearchQuery('');
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 elevation-1">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-text-primary mb-2">Artist Search</h2>
        <p className="text-sm text-text-secondary">
          Search for artists by name or social media handles
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="relative">
          <Input
            type="search"
            placeholder="Enter artist name or social handle..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
            className="pr-12"
            disabled={isSearching}
          />
          {searchQuery && (
            <button
              type="button"
              onClick={handleClear}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-secondary hover:text-text-primary transition-smooth"
            >
              <Icon name="X" size={16} />
            </button>
          )}
        </div>
        
        <div className="flex space-x-3">
          <Button
            type="submit"
            variant="default"
            iconName="Search"
            iconPosition="left"
            disabled={!searchQuery?.trim() || isSearching}
            loading={isSearching}
            className="flex-1 sm:flex-none"
          >
            Search Artists
          </Button>
          
          <Button
            type="button"
            variant="outline"
            iconName="Filter"
            iconPosition="left"
            disabled={isSearching}
          >
            Filters
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SearchInterface;